import React from 'react';
import { Lock, Shield } from 'lucide-react';
interface HeaderProps {
  onAdminClick: () => void;
  isAdminUnlocked: boolean;
}
export function Header({
  onAdminClick,
  isAdminUnlocked
}: HeaderProps) {
  return <header className="w-full px-6 py-6 flex justify-between items-start z-10 relative" data-id="element-323">
      {/* Logo */}
      <div className="w-12 h-12 flex items-center justify-center" data-id="element-324">
        <img src="https://get.clientczar.com/wp-content/uploads/2025/12/ClientCzar-medallion-2-black-1080x1080-1.png" alt="ClientCzar Logo" className="h-12 w-12 object-contain" data-id="element-325" />
      </div>

      {/* Admin Button */}
      <button onClick={onAdminClick} className={`
          flex items-center gap-2 px-4 py-2 rounded-full text-sm font-medium shadow-sm transition-all
          ${isAdminUnlocked ? 'bg-green-50 text-green-700 border border-green-100' : 'bg-white text-gray-600 border border-transparent'}
        `} data-id="element-326">
        {isAdminUnlocked ? <Shield className="w-4 h-4" data-id="element-327" /> : <Lock className="w-4 h-4" data-id="element-328" />}
        <span data-id="element-329">Admin</span>
      </button>
    </header>;
}